/* Circadia client-side A/B — the S5 page-view assignment harness.
   ============================================================================
   Client-Web Analytics (S5). On page view (post-consent) it requests a sticky
   variant for each active experiment from /apps/dashboard/experiment (the server
   reuses the shipped hashToFloat + pickVariant algorithm and the
   experiment_assignments UNIQUE for sticky bucketing + exposure dedup), applies
   the variant as a data attribute the theme can read/style, and fires
   experiment_exposed EXACTLY ONCE (only when the server reports newly_assigned).

   THE HARD GATE: nothing here runs without analytics consent + a visitor id
   (which itself only exists with consent).

   Active experiments come from window.Circadia.experiments (analytics-experiments
   .liquid) — empty at launch; the mechanism ships ready. Loaded with `defer`
   AFTER analytics-emit.js.

   FLICKER NOTE (flagged): assignment is a round-trip, so a visual variant applies
   after first paint. Fine while no experiments run; a pre-paint local-hash assign
   (porting hashToFloat to JS) is the follow-on if flicker matters. */

(function () {
  'use strict';

  var ASSIGN_URL = '/apps/dashboard/experiment';

  function granted() {
    try {
      return !!(
        window.Circadia &&
        window.Circadia.analytics &&
        typeof window.Circadia.analytics.analyticsGranted === 'function' &&
        window.Circadia.analytics.analyticsGranted()
      );
    } catch (_) {
      return false;
    }
  }

  function visitorId() {
    try {
      return window.Circadia &&
        window.Circadia.analytics &&
        typeof window.Circadia.analytics.visitorId === 'function'
        ? window.Circadia.analytics.visitorId()
        : null;
    } catch (_) {
      return null;
    }
  }

  function emit(name, props, extra) {
    try {
      if (window.Circadia && window.Circadia.analytics && window.Circadia.analytics.emit) {
        window.Circadia.analytics.emit(name, props || {}, extra || {});
      }
    } catch (_) {
      /* harness swallows */
    }
  }

  function experimentKeys() {
    var e = window.Circadia && window.Circadia.experiments;
    if (!Array.isArray(e)) return [];
    return e
      .map(function (x) {
        return typeof x === 'string' ? x : x && x.key;
      })
      .filter(Boolean);
  }

  var requested = {}; // de-dupe network requests within a page load

  function assignOne(key, vid) {
    if (requested[key]) return;
    requested[key] = true;
    try {
      fetch(ASSIGN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ experiment_key: key, visitor_id: vid }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.variant) return; // holdout / control / no experiment
          try {
            document.documentElement.setAttribute('data-exp-' + key, data.variant);
          } catch (_) {
            /* attribute set best-effort */
          }
          // experiment_exposed fires ONCE — only on the first (newly-assigned) hit.
          if (data.newly_assigned) {
            emit('experiment_exposed', {}, { experiment_key: key, variant_key: data.variant });
          }
        })
        .catch(function () {
          /* assignment is non-critical — render control */
        });
    } catch (_) {
      /* never break the page */
    }
  }

  function run() {
    if (!granted()) return;
    var vid = visitorId();
    if (!vid) return;
    experimentKeys().forEach(function (k) {
      assignOne(k, vid);
    });
  }

  function init() {
    run();
    // If consent is granted later, run assignment then.
    window.addEventListener('circadia:consent-changed', run);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
